"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
exports.__esModule = true;
var styles = [".text-medium-blue[_ngcontent-%COMP%]{color:#3e53a4}.invalid-feedback[_ngcontent-%COMP%]{display:block}"];
exports.styles = styles;
